import { IAppointmentDetails, IAppointmentItemResponse }
  from "../../services/appointment-list/appointment-list.interface";
import { IAppointmentCreateResponse } from "../../services/create-appointment-v2/create-appointment-v2.interface";

export const actionTypes = {
  SET_ADD_APPOINTMENT_RESPONSE: "SET_ADD_APPOINTMENT_RESPONSE",
  SET_RESCHEDULE_APPOINTMENT_RESPONSE: "SET_RESCHEDULE_APPOINTMENT_RESPONSE",
  SET_VISIT_SELECTED: "SET_VISIT_SELECTED",
  SET_APPOINTMENT_DETAILS: "SET_APPOINTMENT_DETAILS",
  SET_PAST_APPOINTMENTS: "SET_PAST_APPOINTMENTS",
  SET_GROUPED_APPOINTMENTS: "SET_GROUPED_APPOINTMENTS",
};


const setAppointmentsResponse = (payload: IAppointmentCreateResponse | null) => ({
  type: actionTypes.SET_ADD_APPOINTMENT_RESPONSE,
  payload,
});
const setRescheduleAppointmentsResponse = (payload: IAppointmentCreateResponse | null) => ({
  type: actionTypes.SET_RESCHEDULE_APPOINTMENT_RESPONSE,
  payload,
});

const setVisitSelected = (payload: IAppointmentItemResponse | IAppointmentDetails | null) => ({
  type: actionTypes.SET_VISIT_SELECTED,
  payload,
});

const setAppointmentDetails = (payload: IAppointmentDetails | null) => ({
  type: actionTypes.SET_APPOINTMENT_DETAILS,
  payload,
});

const setPastAppointments = (payload: IAppointmentDetails[]) => ({
  type: actionTypes.SET_PAST_APPOINTMENTS,
  payload,
});

const setGroupedAppointments = (payload: IAppointmentDetails[] | null) => ({
  type: actionTypes.SET_GROUPED_APPOINTMENTS,
  payload,
});


export default {
  setAppointmentsResponse,
  setRescheduleAppointmentsResponse,
  setVisitSelected,
  setAppointmentDetails,
  setPastAppointments,
  setGroupedAppointments,
};
